import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Form, Input, message, Modal, Select } from "antd";
import axios from "axios";

import "../styles/DrpCompNavbar.css";
import complog from "../images/DRP_bann_new_comp.png";

const DrpCompNavbar = () => {
  const { Option } = Select;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const [openCourse, setOpenCourse] = useState(false);
  const [certificationsDropdown, setCertificationsDropdown] = useState(false);
  const [openRegister, setOpenRegister] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post(
        "/api/v1/inquiry/contact-form-drp-register",
        values
      );
      message.success(
        response.data.message || "Application submitted successfully!"
      );
      form.resetFields();
      setIsModalVisible(false);
      setMenuOpen(false);
    } catch (error) {
      message.error(
        error.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const location = useLocation();

  const handleDropdownToggle = (dropdownName) => {
    if (dropdownName === "course") {
      setOpenCourse((prev) => !prev);
      setCertificationsDropdown(false);
      setOpenRegister(false);
    } else if (dropdownName === "certifications") {
      setCertificationsDropdown((prev) => !prev);
      setOpenCourse(false);
      setOpenRegister(false);
    } else if (dropdownName === "register") {
      setOpenRegister((prev) => !prev);
      setOpenCourse(false);
      setCertificationsDropdown(false);
    }
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setOpenCourse(false);
    setCertificationsDropdown(false);
    setOpenRegister(false);
  };

  const courses = [
    {
      name: "Trending Courses",
      link: "/courses/Trending-Courses",
      subTabs: [
        "MS - CIT",
        "KLiC Tally",
        "Advanced MS - Office",
        "CIA - Trending Course",
        "ACIP",
        "CBA",
        "Advanced Tally",
        "Advanced Excel",
      ],
    },
    {
      name: "Computer Programming",
      link: "/courses/Computer-Programming",
      subTabs: [
        "Computer Programming - All in one",
        "C Programming",
        "C++ Programming",
        "Python Programming",
        "Advanced Python Programming",
        "Core Java",
        "Advanced Java",
        "C#",
        "ASP.Net",
        "HTML & CSS",
        "SQL",
        "My SQL",
      ],
    },
    {
      name: "New Courses",
      link: "/courses/new-courses",
      subTabs: [
        "3D Character Animation",
        "Share Market",
        "SAP Course",
        "Data Science",
      ],
    },
    {
      name: "Hardware Course",
      link: "/courses/Hardware-Course",
      subTabs: ["Computer Repairing", "Mobile Repairing"],
    },
    {
      name: "Graphic Designing",
      link: "/courses/Graphic-Designing",
      subTabs: [
        "Graphic Design",
        "Adobe Photoshop",
        "Adobe Illustrator",
        "Adobe In Design",
      ],
    },
    {
      name: "Marketing & Video Editing",
      link: "/courses/Marketing-Video-Editing",
      subTabs: [
        "Digital Marketing",
        "Video Editing",
        "Adobe Premier Pro",
        "Adobe After Effects",
      ],
    },
    {
      name: "AutoDesk CAD",
      link: "/courses/AutoDesk-CAD",
      subTabs: [
        "AutoDesk CAD",
        "AutoCAD",
        "AutoCad Mechanical",
        "AutoCad Civil",
        "3Ds Max",
        "Revit",
        "Revit MEP",
        "V-Ray",
      ],
    },
  ];

  return (
    <>
      {menuOpen && (
        <div className="edu-nav-overlay active" onClick={closeMenu}></div>
      )}

      <nav className="edu-navbar-container">
        <div className="edu-navbar-logo">
          <Link to="/drpComputerEducation">
            <img src={complog} alt="DRP Computer Education" />
          </Link>
        </div>

        <div
          className="edu-navbar-menu-icon"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </div>

        <ul className={`edu-navbar-links ${menuOpen ? "active" : ""}`}>
          <div className="edu-navbar-close-icon" onClick={closeMenu}>
            ✕
          </div>

          <li
            className={`edu-navbar-item ${
              location.pathname === "/" ? "active" : ""
            }`}
          >
            <Link to="/" className="edu-navbar-link" onClick={closeMenu}>
              Welcome!
            </Link>
          </li>
          <li
            className={`edu-navbar-item ${
              location.pathname === "/drpComputerEducation" ? "active" : ""
            }`}
          >
            <Link
              to="/drpComputerEducation"
              className="edu-navbar-link"
              onClick={closeMenu}
            >
              Home
            </Link>
          </li>

          <li
            className={`edu-navbar-dropdown ${
              location.pathname.includes("/courses") ? "active" : ""
            } ${openCourse ? "open" : ""}`}
            onMouseEnter={() => !menuOpen && setOpenCourse(true)}
            onMouseLeave={() => !menuOpen && setOpenCourse(false)}
          >
            <button
              className="edu-navbar-dropbtn"
              onClick={() => menuOpen && handleDropdownToggle("course")}
            >
              Courses
            </button>

            <div className="edu-navbar-course-dropdown">
              {courses.map((course, index) => (
                <div
                  key={index}
                  className="edu-navbar-course-tab"
                  onMouseEnter={() => setActiveTab(index)}
                  onMouseLeave={() => setActiveTab(null)}
                >
                  <Link
                    to={course.link}
                    className="edu-navbar-course-title"
                    onClick={closeMenu}
                  >
                    {course.name}
                  </Link>

                  {(activeTab === index || menuOpen) && (
                    <div className="edu-navbar-sub-tabs">
                      {course.subTabs.map((sub, subIndex) => (
                        <div key={subIndex} className="edu-navbar-sub-tab">
                          {sub}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </li>

          <li
            className={`edu-navbar-dropdown-item ${
              [
                "/compTraning/ManualTesting",
                "/compTraning/AutomationTesting",
                "/compTraning/JavaFullStackDevelopment",
                "/compTraning/SalesForce",
                "/compTraning/DataScience",
                "/compTraning/RESTAPITesting",
                "/compTraning/NetFullstackDevelopment",
                "/compTraning/ReactJsDevelopment",
                "/compTraning/RPA",
                "/compTraning/Hardware&Networking",
              ].includes(location.pathname)
                ? "active"
                : ""
            } ${certificationsDropdown ? "open" : ""}`}
            onMouseEnter={() => !menuOpen && setCertificationsDropdown(true)}
            onMouseLeave={() => !menuOpen && setCertificationsDropdown(false)}
          >
            <span
              className="edu-navbar-dropdown-toggle"
              onClick={() => menuOpen && handleDropdownToggle("certifications")}
            >
              IT Certifications
            </span>

            <ul className="edu-navbar-dropdown-menu">
              <li
                className={
                  location.pathname === "/compTraning/ManualTesting"
                    ? "active"
                    : ""
                }
              >
                <Link to="/compTraning/ManualTesting" onClick={closeMenu}>
                  Manual Testing
                </Link>
              </li>
              <li
                className={
                  location.pathname === "/compTraning/AutomationTesting"
                    ? "active"
                    : ""
                }
              >
                <Link to="/compTraning/AutomationTesting" onClick={closeMenu}>
                  Automation Testing (Python Or Java Selenium)
                </Link>
              </li>
              <li
                className={
                  location.pathname === "/compTraning/JavaFullStackDevelopment"
                    ? "active"
                    : ""
                }
              >
                <Link
                  to="/compTraning/JavaFullStackDevelopment"
                  onClick={closeMenu}
                >
                  Java Full Stack Development
                </Link>
              </li>
              <li
                className={
                  location.pathname === "/compTraning/SalesForce"
                    ? "active"
                    : ""
                }
              >
                <Link to="/compTraning/SalesForce" onClick={closeMenu}>
                  SalesForce
                </Link>
              </li>
              <li
                className={
                  location.pathname === "/compTraning/DataScience"
                    ? "active"
                    : ""
                }
              >
                <Link to="/compTraning/DataScience" onClick={closeMenu}>
                  Data Science
                </Link>
              </li>
              <li
                className={
                  location.pathname === "/compTraning/RESTAPITesting"
                    ? "active"
                    : ""
                }
              >
                <Link to="/compTraning/RESTAPITesting" onClick={closeMenu}>
                  REST API Testing
                </Link>
              </li>
              <li
                className={
                  location.pathname === "/compTraning/NetFullstackDevelopment"
                    ? "active"
                    : ""
                }
              >
                <Link
                  to="/compTraning/NetFullstackDevelopment"
                  onClick={closeMenu}
                >
                  .Net Full Stack Development
                </Link>
              </li>
              <li
                className={
                  location.pathname === "/compTraning/ReactJsDevelopment"
                    ? "active"
                    : ""
                }
              >
                <Link to="/compTraning/ReactJsDevelopment" onClick={closeMenu}>
                  React Js Development
                </Link>
              </li>
              <li
                className={
                  location.pathname === "/compTraning/RPA" ? "active" : ""
                }
              >
                <Link to="/compTraning/RPA" onClick={closeMenu}>
                  RPA (Robotic Process Automation)
                </Link>
              </li>
              <li
                className={
                  location.pathname === "/compTraning/Hardware&Networking"
                    ? "active"
                    : ""
                }
              >
                <Link to="/compTraning/Hardware&Networking" onClick={closeMenu}>
                  Hardware & Networking (CCNA, CCIE, CCNP)
                </Link>
              </li>
            </ul>
          </li>

          <li
            className={`edu-navbar-dropdown ${
              location.pathname === "/register" ? "active" : ""
            } ${openRegister ? "open" : ""}`}
            onMouseEnter={() => !menuOpen && setOpenRegister(true)}
            onMouseLeave={() => !menuOpen && setOpenRegister(false)}
          >
            <button
              className="edu-navbar-dropbtn"
              onClick={() => menuOpen && handleDropdownToggle("register")}
            >
              Register
            </button>
            <div className="edu-navbar-dropdown-content">
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  showModal();
                  closeMenu();
                }}
              >
                Drp Computer Education
                <br /> And training Institute
              </Link>
            </div>
          </li>

          <li
            className={`edu-navbar-item ${
              location.pathname === "/drpCompAbout" ? "active" : ""
            }`}
          >
            <Link
              to="/drpCompAbout"
              className="edu-navbar-link"
              onClick={closeMenu}
            >
              About
            </Link>
          </li>
          <li
            className={`edu-navbar-item ${
              location.pathname === "/drpcompContact" ? "active" : ""
            }`}
          >
            <Link
              to="/drpcompContact"
              className="edu-navbar-link"
              onClick={closeMenu}
            >
              Contact
            </Link>
          </li>
        </ul>
      </nav>

      <Modal
        title="Register for DRP Computer Education & Training Institute"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
        className="registration-modal"
      >
        <Form
          layout="vertical"
          onFinish={handleFinish}
          initialValues={{
            serviceName: "DRP Computer Education & Training Institute",
          }}
          className="registration-form"
          form={form}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please enter your name" }]}
            className="registration-form-item"
          >
            <Input
              placeholder="Enter your name"
              className="registration-input"
            />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                message: "Please enter your email",
                type: "email",
              },
            ]}
            className="registration-form-item"
          >
            <Input
              placeholder="Enter your email"
              className="registration-input"
            />
          </Form.Item>

          <Form.Item
            label="Phone"
            name="contact"
            rules={[
              { required: true, message: "Please enter your phone number" },
            ]}
            className="registration-form-item"
          >
            <Input
              placeholder="Enter your phone number"
              className="registration-input"
            />
          </Form.Item>

          <Form.Item
            label="Select Service"
            name="serviceName"
            className="registration-form-item"
          >
            <Select className="registration-select">
              <Option value="DRP Computer Education & Training Institute">
                DRP Computer Education & Training Institute
              </Option>
            </Select>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              className="registration-submit-btn"
              loading={loading}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default DrpCompNavbar;
